import types from './types';
import update from '../../../../../utilities/updateStateUtilities';
import MediaPickersConstants from '../MediaPickersConstants';
import { MEDIA_USAGE_TYPE } from '../../CreatePageConstants';

const INITIAL_STATE = {
    logoMediaPickerOpen: false,
    backgroundMediaPickerOpen: false,

    imageCropperVisible: false,
    imageCropperProcessing: false,
    imageCropperData: undefined,

    // Users pick their own uploads far more often than a stock photo, so the gallery opens on
    // My Assets. Stock images stay one click away.
    logoPickerSelectedTab: MediaPickersConstants.MEDIA_PICKER_TABS.MY_ASSETS,
    backgroundPickerSelectedTab: MediaPickersConstants.MEDIA_PICKER_TABS.MY_ASSETS,

    // Image elements picker. It shows the same two galleries as the logo picker, but keeps its own
    // state for them: see the note on the image stock image keys below.
    imageElementMediaPickerOpen: false,
    imageMediaPickerOpen: false,
    imageElementPickerSelectedTab: MediaPickersConstants.MEDIA_PICKER_TABS.MY_ASSETS,
    imagePickerSelectedTab: MediaPickersConstants.MEDIA_PICKER_TABS.MY_ASSETS,
    // null means the picked image is added as a new element, a number replaces that element's media.
    imageElementPickerTargetIndex: null,
    imagePickerTargetIndex: null,

    // Stock images for logo

    logoStockImagesInitializing: false,
    logoStockImagesLoading: false,
    logoStockImagesSearching: false,
    logoStockImagesOrientation: MediaPickersConstants.STOCK_MEDIA_ORIENTATION.SQUARE,

    logoStockImagesSearchValue: '',
    logoStockImagesDefaultKeyword: null,

    logoStockImages: [],
    logoStockImagesAllCount: 0,
    logoStockImagesPageNumber: 1,

    // The image elements gallery is deliberately separate from the logo one: it searches every
    // orientation and asks the API for the image usage type, so sharing state would cross the two.
    imageElementStockImagesInitializing: false,
    imageStockImagesInitializing: false,
    imageElementStockImagesLoading: false,
    imageStockImagesLoading: false,
    imageElementStockImagesSearching: false,
    imageStockImagesSearching: false,
    imageElementStockImagesOrientation: MediaPickersConstants.STOCK_MEDIA_ORIENTATION.ALL_ORIENTATIONS,
    imageStockImagesOrientation: MediaPickersConstants.STOCK_MEDIA_ORIENTATION.ALL_ORIENTATIONS,
    imageElementStockImagesSearchValue: '',
    imageStockImagesSearchValue: '',
    imageElementStockImagesDefaultKeyword: null,
    imageStockImagesDefaultKeyword: null,
    imageElementStockImages: [],
    imageStockImages: [],
    imageElementStockImagesAllCount: 0,
    imageStockImagesAllCount: 0,
    imageElementStockImagesPageNumber: 1,
    imageStockImagesPageNumber: 1,

    // Stock images for background

    backgroundStockImagesInitializing: false,
    backgroundStockImagesLoading: false,
    backgroundStockImagesSearching: false,
    backgroundStockImagesOrientation: MediaPickersConstants.STOCK_MEDIA_ORIENTATION.HORISONTAL,
   
    backgroundStockImagesSearchValue: '',
    backgroundStockImagesDefaultKeyword: null,
    backgroundStockImages: [],
    backgroundStockImagesAllCount: 0,
    backgroundStockImagesPageNumber: 1,

    // Stock videos for background

    backgroundStockVideosLoading: false,
    backgroundStockVideoTabVisible: false,
    backgroundStockVideosSearching: false,
    backgroundStockVideoPreviewVisible: false,
    backgroundStockVideoPreviewProcessing: false,
    backgroundStockVideoPreviewData: undefined,

    backgroundStockVideosSearchValue: '',
    backgroundStockVideos: [],
    backgroundStockVideosAllCount: 0,
    backgroundStockVideosPageNumber: 1,
    backgroundStockVideosOrientation: MediaPickersConstants.STOCK_MEDIA_ORIENTATION.HORISONTAL,
    
    // Catalog Videos for background

    backgroundCatalogVideosInitializing: false,
    backgroundCatalogVideosLoading: false,

    backgroundCatalogVideos: [],
    backgroundCatalogVideosAllCount: 0,
    backgroundCatalogVideosPageNumber: 1,

    catalogVideoPreviewVisible: false,
    catalogVideoPreviewProcessing: false,
    catalogVideoPreviewData: undefined,

    premiumVideosDialogData: {
        dialogOpen: false,
        videoUrl: null,
        onGoBack: null
    },

    // User Assets (User's images and videos)

    userAssetsInitializing: false,
    userAssets: [],

    backgroundAssetsLoading: false,
    backgroundAssets: [],
    backgroundAssetsPageNumber: 1,
    backgroundAssetsCount: undefined,

    logoAssetsLoading: false,
    logoAssets: [],
    logoAssetsPageNumber: 1,
    logoAssetsCount: undefined,

    imageElementAssetsLoading: false,
    imageAssetsLoading: false,
    imageElementAssets: [],
    imageAssets: [],
    imageElementAssetsPageNumber: 1,
    imageAssetsPageNumber: 1,
    imageElementAssetsCount: undefined,
    imageAssetsCount: undefined
}

const mediaPickerReducer = (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case types.SET_PROPERTY: {
            let newState = update.set(state, action.key, action.value);
            if (action.key.startsWith('imageElement')) {
                const legacyKey = 'image' + action.key.slice('imageElement'.length);
                newState = update.set(newState, legacyKey, action.value);
            } else if (action.key.startsWith('image') && !action.key.startsWith('imageCropper') && !action.key.startsWith('imageElement')) {
                const newKey = 'imageElement' + action.key.slice('image'.length);
                newState = update.set(newState, newKey, action.value);
            }
            return newState;
        }

        case types.SET_LOGO_STOCK_IMAGES: {
            const clearImages = state.logoStockImagesPageNumber === action.pageNumber || action.pageNumber === 1;
            return {
                ...state,
                logoStockImages: clearImages ? action.images : [...state.logoStockImages, ...action.images],
                logoStockImagesAllCount: action.allItemsCount,
                logoStockImagesPageNumber: action.pageNumber
            };
        }

        case types.SET_IMAGE_STOCK_IMAGES: {
            const clearImages = (state.imageElementStockImagesPageNumber || state.imageStockImagesPageNumber) === action.pageNumber || action.pageNumber === 1;
            const updatedImages = clearImages ? action.images : [...(state.imageElementStockImages || state.imageStockImages), ...action.images];
            return {
                ...state,
                imageElementStockImages: updatedImages,
                imageStockImages: updatedImages,
                imageElementStockImagesAllCount: action.allItemsCount,
                imageStockImagesAllCount: action.allItemsCount,
                imageElementStockImagesPageNumber: action.pageNumber,
                imageStockImagesPageNumber: action.pageNumber
            };
        }

        case types.CLEAR_IMAGE_STOCK_IMAGES: {
            return {
                ...state,
                imageElementStockImages: [],
                imageStockImages: [],
                imageElementStockImagesAllCount: 0,
                imageStockImagesAllCount: 0,
                imageElementStockImagesPageNumber: 1,
                imageStockImagesPageNumber: 1,
                imageElementStockImagesOrientation: MediaPickersConstants.STOCK_MEDIA_ORIENTATION.ALL_ORIENTATIONS,
                imageStockImagesOrientation: MediaPickersConstants.STOCK_MEDIA_ORIENTATION.ALL_ORIENTATIONS,
                imageElementStockImagesDefaultKeyword: null,
                imageStockImagesDefaultKeyword: null
            };
        }

        case types.CLEAR_LOGO_STOCK_IMAGES: {
            return {
                ...state,
                logoStockImages: [],
                logoStockImagesAllCount: 0,
                logoStockImagesPageNumber: 1,
                logoStockImagesOrientation: MediaPickersConstants.STOCK_MEDIA_ORIENTATION.SQUARE,
                logoStockImagesDefaultKeyword: null,
            };
        }

        case types.SET_BACKGROUND_STOCK_IMAGES: {
            const clearImages = state.backgroundStockImagesPageNumber === action.pageNumber || action.pageNumber === 1;
            return {
                ...state,
                backgroundStockImages: clearImages ? action.images : [...state.backgroundStockImages, ...action.images],
                backgroundStockImagesAllCount: action.allItemsCount,
                backgroundStockImagesPageNumber: action.pageNumber
            };
        }

        case types.CLEAR_BACKGROUND_STOCK_IMAGES: {
            return {
                ...state,
                backgroundStockImages: [],
                backgroundStockImagesAllCount: 0,
                backgroundStockImagesPageNumber: 1,
                backgroundStockImagesOrientation: MediaPickersConstants.STOCK_MEDIA_ORIENTATION.HORISONTAL,
                backgroundStockImagesDefaultKeyword: null,
            };
        }

        case types.SET_BACKGROUND_CATALOG_VIDEOS: {
            return {
                ...state,
                backgroundCatalogVideos: (state.backgroundCatalogVideos.length) ? [...state.backgroundCatalogVideos, ...action.videos] : action.videos,
                backgroundCatalogVideosAllCount: action.allItemsCount,
                backgroundCatalogVideosPageNumber: action.pageNumber
            };
        }

        case types.CLEAR_BACKGROUND_CATALOG_VIDEOS: {
            return {
                ...state,
                backgroundCatalogVideos: [],
                backgroundCatalogVideosAllCount: 0,
                backgroundCatalogVideosPageNumber: 1
            };
        }


        case types.SET_BACKGROUND_STOCK_VIDEOS: {
            const clearVideos = state.backgroundStockVideosPageNumber === action.pageNumber || action.pageNumber === 1;

            return {
                ...state,
                backgroundStockVideos: clearVideos ? action.videos : [...state.backgroundStockVideos, ...action.videos],
                backgroundStockVideosAllCount: action.allItemsCount,
                backgroundStockVideosPageNumber: action.pageNumber
            };
        }

        case types.CLEAR_BACKGROUND_STOCK_VIDEOS: {
            return {
                ...state,
                backgroundStockVideos: [],
                backgroundStockVideosAllCount: 0,
                backgroundStockVideosPageNumber: 1,
                backgroundStockVideoTabVisible : false,
                backgroundStockVideosSearchValue: '',
                backgroundStockVideosOrientation: MediaPickersConstants.STOCK_MEDIA_ORIENTATION.HORISONTAL,
            };
        }

        case types.SET_USER_IMAGE_ASSETS: {
            const { assets, pageNumber, count } = action;
            const currentAssets = state.imageElementAssets || state.imageAssets || [];
            const merged = [...currentAssets, ...assets.filter(asset => !currentAssets.some(existing => existing.id === asset.id))];

            return {
                ...state,
                imageElementAssets: merged,
                imageAssets: merged,
                imageElementAssetsPageNumber: pageNumber,
                imageAssetsPageNumber: pageNumber,
                imageElementAssetsCount: count,
                imageAssetsCount: count
            };
        }

        case types.SET_USER_LOGO_ASSETS: {
            const { logoAssets, pageNumber, count } = action;
            const filteredLogoAssets = [...state.logoAssets, ...logoAssets.filter(newLogo => !state.logoAssets.some(existingLogo => existingLogo.id === newLogo.id))];
            
            return {
                ...state,
                logoAssets: filteredLogoAssets,
                logoAssetsPageNumber: pageNumber,
                logoAssetsCount: count         
            };
        }

        case types.SET_USER_BACKGROUND_ASSETS: {
            const { backgroundAssets, pageNumber, count } = action;
            const filteredBackgroundAssets = [...state.backgroundAssets, ...backgroundAssets.filter(newBackground => !state.backgroundAssets.some(existingBackground => existingBackground.id === newBackground.id))];

            return {
                ...state,
                backgroundAssets: filteredBackgroundAssets,
                backgroundAssetsPageNumber: pageNumber,
                backgroundAssetsCount: count         
            };
        }

        case types.ADD_USER_LOGO_ASSET: {
            const { asset } = action;

            return {
                ...state,
                logoAssets: [asset, ...state.logoAssets]
            }
        }

        case types.ADD_USER_IMAGE_ASSET: {
            const { asset } = action;

            return {
                ...state,
                imageElementAssets: [asset, ...(state.imageElementAssets || [])],
                imageAssets: [asset, ...(state.imageAssets || [])]
            }
        }

        case types.ADD_USER_BACKGROUND_ASSET: {
            const { asset } = action;

            return {
                ...state,
                backgroundAssets: [asset, ...state.backgroundAssets]
            }
        }
    

        case types.CLEAR_USER_ASSETS: {
            return {
                ...state,
                userAssets: []
            };
        }

        case types.REMOVE_USER_ASSET: {
            const { id, usageType } = action;

            if (usageType === MEDIA_USAGE_TYPE.BACKGROUND) {
                return {
                    ...state,
                    backgroundAssets: state.backgroundAssets.filter(asset => asset.id !== id),
                };
            } else if (usageType === MEDIA_USAGE_TYPE.LOGO) {
                return {
                    ...state,
                    logoAssets: state.logoAssets.filter(asset => asset.id !== id),
                };
            } else if (usageType === MEDIA_USAGE_TYPE.IMAGE_ELEMENT) {
                return {
                    ...state,
                    imageElementAssets: (state.imageElementAssets || []).filter(asset => asset.id !== id),
                    imageAssets: (state.imageAssets || []).filter(asset => asset.id !== id),
                };
            } else {
                return {
                    ...state
                }
            }
        }

        case types.SHOW_IMAGE_CROPPER: {
            return {
                ...state,
                imageCropperVisible: true,
                imageCropperData: {
                    data: action.data,
                    format: action.format,
                    mediaSourceType: action.mediaSourceType,
                    mediaUsageType: action.mediaUsageType,
                    mediaResourceId: action.mediaResourceId,
                    mediaResourceUrl: action.mediaResourceUrl,
                    particleIndex: action.particleIndex
                }
            };
        }

        case types.HIDE_IMAGE_CROPPER: {
            return {
                ...state,
                imageCropperVisible: false,
                imageCropperData: undefined
            };
        }

        case types.SHOW_CATALOG_VIDEO_PREVIEW: {
            return {
                ...state,
                catalogVideoPreviewVisible: true,
                catalogVideoPreviewData: {
                    catalogVideoId: action.catalogVideoId,
                    isPremium: action.isPremium,
                    urls: action.urls
                }
            };
        }

        case types.HIDE_CATALOG_VIDEO_PREVIEW: {
            return {
                ...state,
                catalogVideoPreviewVisible: false,
                catalogVideoPreviewData: undefined
            };
        }

        case types.SHOW_STOCK_VIDEO_PREVIEW: {
            return {
                ...state,
                backgroundStockVideoPreviewVisible: true,
                backgroundStockVideoPreviewData: {
                    stockVideoId: action.stockVideoId,
                    isPremium: action.isPremium,
                    urls: action.urls,
                }
            };
        }

        case types.HIDE_STOCK_VIDEO_PREVIEW: {
            return {
                ...state,
                backgroundStockVideoPreviewVisible: false,
                backgroundStockVideoPreviewData: undefined
            };
        }

        case types.OPEN_PREMIUM_VIDEOS_DIALOG: {
            return {
                ...state,
                premiumVideosDialogData: {
                    dialogOpen: true,
                    videoUrl: action.videoUrl,
                    onGoBack: action.onGoBack
                },
            };
        }

        case types.CLOSE_PREMIUM_VIDEOS_DIALOG: {
            return {
                ...state,
                premiumVideosDialogData: {
                    dialogOpen: false,
                    videoUrl: null,
                    onGoBack: null
                },
            };
        }

        default: return state;
    }
}

export default mediaPickerReducer;